import ApiService from "./api.service";

const BTrainingService = {
  async trainings(type = "") {
    try {
      const params = {};

      if (type.length > 0) {
        params.type = type;
      }

      return await ApiService.get("btrainings/all", { params });
    } catch (error) {
      console.log(error);
    }
  },

  async training(id) {
    try {
      return await ApiService.get("btrainings/" + id + "/show/langs");
    } catch (error) {
      console.log(error);
    }
  },

  async bTrainingTypes() {
    try {
      return await ApiService.get("bTrainingTypes");
    } catch (error) {
      return error.response;
    }
  },

  async bTrainingCosts() {
    try {
      return await ApiService.get("bTrainingCosts");
    } catch (error) {
      return error.response;
    }
  },

  async bTrainingDetails(trainingId) {
    try {
      return await ApiService.get(`btrainings/details/langs/${trainingId}`);
    } catch (error) {
      return error.response;
    }
  },

  async storeResult(data) {
    try {
      return await ApiService.post("btrainings/result", data);
    } catch (e) {
      console.log(e);
    }
  },
};

export { BTrainingService };
